export default __webpack_public_path__ + "static/epilogue-89f559625d5f7f5ee8533f1eda9c051b.svg";